import { TQLHILinkTypeDTO } from './hi-link';
import { ExpressionEnum } from './link-expression';
import { SeverityDTO } from './severity';
import { z } from 'zod/v4';

const TreeExpressionDTO = z.nativeEnum(ExpressionEnum).nullable();

const TreeHiddenReasonDTO = z.enum(['ci', 'hi_type']);

export const TreeLeafAlertDTO = z.object({
  id: z.string(),
  caused: z.boolean(),
  value: z.number(),
  starts_at: z.string(),
  ends_at: z.string().nullable(),
  duration_sec: z.number(),
  active: z.boolean(),
  before_root_sec: z.number(),
  is_manual_closable: z.boolean(),
  closed_user_login: z.string().nullable(),
  labels: z.record(z.string(), z.any()),
  annotations: z.object({
    summary: z.string().nullable(),
    description: z.string().nullable(),
  }),
});
export type TreeLeafAlert = z.infer<typeof TreeLeafAlertDTO>;

export const TreeNodeBaseDTO = z.object({
  hi_id: z.string().nullable(),
  ci_id: z.string().nullable(),
  ci_name: z.string().nullable(),
  ci_type_name: z.string().nullable(),
  hi_type_name: z.string().nullable(),
  hi_type_label: z.string().nullable(),
  type: TQLHILinkTypeDTO.nullable(),
  is_accessible: z.boolean(),
  hidden_reason: TreeHiddenReasonDTO.nullable(),
  severity: SeverityDTO.nullable(),
  sot_id: z.string().nullable(),
  status_since: z.string().nullable(),
  expression: TreeExpressionDTO,
  depth: z.number().int(),
  is_leaf: z.boolean(),
  is_repeated: z.boolean(),
  depth_exceeded: z.boolean(),
  children_omitted: z.number().int(),
});
export type TreeNodeBase = z.infer<typeof TreeNodeBaseDTO>;

export const TreeDownNodeDTO = TreeNodeBaseDTO.extend({
  weight: z.number().nullable(),
  is_root_cause_path: z.boolean(),
  any_one_is_enough: z.boolean().nullable(),
  is_dead_end: z.boolean(),
  children_hidden: z.number().int(),
  alerts: z.array(TreeLeafAlertDTO).nullable(),
  alerts_total: z.number().nullable(),
  children: z.array(z.lazy(() => TreeDownNodeDTO)),
});
export type TreeDownNode = z.infer<typeof TreeDownNodeDTO>;

export const TreeUpNodeDTO = TreeNodeBaseDTO.extend({
  is_affected: z.boolean().nullable(),
  affected_severity: SeverityDTO.nullable(),
  affected_since: z.string().nullable(),
  children: z.array(z.lazy(() => TreeUpNodeDTO)),
});
export type TreeUpNode = z.infer<typeof TreeUpNodeDTO>;

export const TreeDownResponseDTO = z.object({
  at: z.string(),
  root: TreeDownNodeDTO,
  nodes_total: z.number().int(),
  truncated: z.boolean(),
});
export type TreeDownResponse = z.infer<typeof TreeDownResponseDTO>;

export const TreeUpResponseDTO = z.object({
  at: z.string(),
  root: TreeUpNodeDTO,
  nodes_total: z.number().int(),
  truncated: z.boolean(),
});
export type TreeUpResponse = z.infer<typeof TreeUpResponseDTO>;

export const TreeRequestDTO = z.object({
  sot_id: z.uuid(),
  at: z.string().optional(),
  max_depth: z.number().int().min(1).max(20).default(10),
  max_children: z.number().int().min(1).max(500).default(50),
});
export type TreeRequest = z.input<typeof TreeRequestDTO>;
